<div class="metric-card-details" [id]="metricCard.id">
  <div class="metric-card-details-wrapper" [ngClass]="metricCard.topCircleColor && 'top-circle'">
    @if (metricCard.topCircleColor) {
      <div class="circle-title-container">
        <span class="circle" [style.backgroundColor]="metricCard.topCircleColor"></span>
        <div class="metric-card-title">
          {{ metricCard.title }}
        </div>
      </div>
    } @else {
      @if (metricCard.title) {
        <div class="metric-card-title">
          {{ metricCard.title }}
        </div>
      }
    }


    <div class="metric-card-value">
      <span [ngClass]="{ 'value1-error': metricCard.value1Color }">
        {{ metricCard.value || metricCard.value === 0 ? metricCard.value : ('&#8734;' | decodeHtmlString) }}
      </span>
      @if (metricCard.isValue2Available) {
        <span>
          /
        </span>
      }
      @if (metricCard.isValue2Available) {
        <span [ngClass]="{ 'value2-error': metricCard.value2Color }">
          {{ metricCard.value2 || metricCard['value2'] === 0 ? metricCard.value2 : ('&#8734;' | decodeHtmlString) }}
        </span>
      }
    </div>
  </div>
  @if (metricCard.clickable) {
    <button type="button" class="report-button" (click)="handleCardClick()">
      {{ metricCard.clickText ? metricCard.clickText : 'FLIGHTS' }}
    </button>
  }
  @if (!metricCard.noBorderLine) {
    <div class="metric-card-border" [ngClass]="{ 'metric-card-value-bordered': !isLastChild }"></div>
  }
</div>
